<template>
  <div class="search-container">
    <img class="lupa" src="lupa.svg" />
    <input
      class="search-input"
      type="text"
      v-model="search"
      placeholder="Buscar por obra o autor"
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: '',
    }
  },
  computed: {
    searchString: function(){return this.$store.getters.getSearch},
  },
  watch: {
    search() {
      this.$store.commit('updateSearch', this.search);
    },
    searchString() {
      if (!this.searchString) this.search = '';
    }
  }
}
</script>

<style scoped>
.search-container {
  display: flex;
  align-items: center;
  border-bottom: 2px solid #aa4700;
}

.search-input, input:focus{
  outline: none;
}

.search-input {
  background-color: var(--white);
  width: 14em;
}

.lupa {
  height: 1em;
  margin-right: 0.3em;
}
</style>
